import { ClientTypes } from './actionTypes';

const INIT_STATE = {
  CountItems: 0,
  clients: [],
  clientsDetail: {},
  clientsAdd: {},
  deleteId: undefined,
  clientsUpdate: {},
  error: {},
  brandCustom: {},
  errorTestEmail: "",
  messageTestEmail: "",
  isLoading: false,
};

const Clients = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    //GET CLIENT
    case ClientTypes.GET_CLIENTS:
      state = {
        ...state,
        isLoading: true,
      };
      break;
    case ClientTypes.GET_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: action.payload.listData,
        CountItems: action.payload.CountItems,
        clientsAdd: {},
        isLoading: false,
      };
    case ClientTypes.GET_CLIENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        clients: [],
        clientsAdd: {},
        isLoading: false,
      };

    //GET CLIENTS DETAIls
    case ClientTypes.GET_CLIENTS_DETAIL_SUCCESS:
      return {
        ...state,
        clientsDetail: action.payload,
      };

    case ClientTypes.GET_CLIENTS_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    // ADD CLIENTs
    case ClientTypes.ADD_CLIENTS:
      return {
        ...state,
        isLoading: true,
      };
    case ClientTypes.ADD_CLIENTS_SUCCESS:
      return {
        ...state,
        clientsAdd: action.payload,
      };
    case ClientTypes.ADD_CLIENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    // DELETE CLIENTs
    case ClientTypes.DELETE_CLIENTS:
      state = { ...state, isLoading: true };
      break;
    case ClientTypes.DELETE_CLIENTS_SUCCESS:
      return {
        ...state,
        deleteId: action.payload,
      };
    case ClientTypes.DELETE_CLIENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    // UPDATE CLIENTES
    case ClientTypes.UPDATE_CLIENTS:
      return {
        ...state,
        isLoading: true,
      };
    case ClientTypes.UPDATE_CLIENTS_SUCCESS:
      return {
        ...state,
        clientsUpdate: action.payload,
      };
    case ClientTypes.UPDATE_CLIENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case ClientTypes.GET_BRAND_CUSTOM:
      state = { ...state };
      break;
    case ClientTypes.GET_BRAND_CUSTOM_SUCCESS:
      return {
        ...state,
        brandCustom: action.payload,
      };
    case ClientTypes.GET_BRAND_CUSTOM_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    //TEST EMAIL 
    case ClientTypes.SEND_TEST_EMAIL:
      state = {
        ...state,
        errorTestEmail: "",
        messageTestEmail: "",
        isLoading: true
      };
      break;
    case ClientTypes.SEND_TEST_EMAIL_SUCCESS:
      return {
        ...state,
        errorTestEmail: action.payload.success,
        messageTestEmail: action.payload.message,
        isLoading: false
      };
    case ClientTypes.SEND_TEST_EMAIL_FAIL:
      return {
        ...state,
        errorTestEmail: false,
        messageTestEmail: action.payload,
        isLoading: false
      };


    default:
      break;
  }
  return state;
};

export default Clients;
